import type { Router } from 'vue-router';
import { type IApplicationInsights } from '@microsoft/applicationinsights-web';
import { generateW3CId } from '@microsoft/applicationinsights-core-js';

export function setupPageTracking(
    router: Router,
    appInsights: IApplicationInsights,
    appName: string
) {
    router.beforeEach((route, _from, next) => {
        const routeName =
            typeof route.name === 'string'
                ? route.name
                : route.name?.toString();
        const name = appName + ' / ' + routeName;
        appInsights.context.telemetryTrace.traceID = generateW3CId();
        appInsights.context.telemetryTrace.name = routeName;
        appInsights.startTrackPage(name);
        next();
    });

    router.afterEach((route) => {
        const routeName =
            typeof route.name === 'string'
                ? route.name
                : route.name?.toString();
        const name = appName + ' / ' + routeName;
        const url = location.protocol + '//' + location.host + route.fullPath;

        appInsights.stopTrackPage(name, url);
        appInsights.flush();
    });
}
